import { DataBean } from "../DataBean";

export class BankingConciliation extends DataBean {


    public async getBankingConciliation(date:any,idBankingAccount:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliation_getBankingConciliation_java.util.Date_Number", [date,idBankingAccount]);
    }
public async getBankingConciliationDatawhityear(idBankingAccount:any,year:any,month:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliation_getBankingConciliationData_Number_Number_Number", [idBankingAccount,year,month]);
    }

     public async addBankingConciliationDataInfo(idBankingConciliation:any,description:any,date:any,value:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliation_addBankingConciliationDataInfo_Number_String_java.util.Date_Number", [idBankingConciliation,description,date,value]);
    }

}